import React from "react";

import './Header.scss';

export default function Header() {
  return (
    <div className="Header">
      <div className="img-container">
        <img src="./images/header.jpg" alt="header"/>
        <header>
          <h1>METH</h1>
          <div className="byline">By <a href="https://sylphdapps.com" target="_blank" rel="noreferrer">Sylph Dapps</a></div>
        </header>
      </div>     
    </div>
  );
}